<button
  class="{{ props }} {{
    full ? 'tw-w-full' : ''
  }} tw-justify-center tw-items-center tw-gap-2 tw-inline-flex tw-capitalize {{
    className
  }} {{
    disabled && !color?.toLowerCase().includes('link') ? '!tw-bg-[#e1e1e5]' : ''
  }}"
  (click)="handleOnClick($event)"
  [type]="type"
  [disabled]="disabled"
>
  <div class="tw-font-normal tw-flex tw-items-center">
    @if (!!startIcon) {
      <span
        class="material-icons tw-mr-1"
        [style.font-size]="small ? '18px !important' : '24px !important'"
        >{{ startIcon }}</span
      >
    }
    <div class="tw-ml-0"><ng-content></ng-content>{{ content }}</div>
    <ng-content></ng-content>{{ content }}
    @if (!!endIcon) {
      <span
        class="material-icons tw-ml-1"
        [style.font-size]="small ? '18px !important' : '24px !important'"
        >{{ endIcon }}</span
      >
    }
    @if (loading) {
      <i class="tw-ml-3"><cohrex-spinner className="!tw-w-5 !tw-h-5 " /></i>
    }
  </div>
</button>
